import { useId } from "react";

export const AnimatedLogo = ({ className = "", orbit = true }) => {
    const uid = useId().replace(/:/g, "");
    const orbitPathId = `orbit-path-${uid}`;
    const ringGradId = `ring-grad-${uid}`;
    const glowId = `pulse-glow-${uid}`;

    return (
        <div className={`relative ${className}`} data-testid="logo-fx">
            <div
                className="logo-fx-glow-pulse absolute -inset-[16%] rounded-full bg-[radial-gradient(circle,rgba(230,28,36,0.42),rgba(0,240,255,0.12)_55%,transparent_72%)] blur-2xl"
                aria-hidden="true"
            />
            {orbit && (
                <svg
                    viewBox="0 0 400 400"
                    className="animate-orbit-spin absolute -inset-[11%] h-[122%] w-[122%]"
                    aria-hidden="true"
                >
                    <defs>
                        <linearGradient
                            id={ringGradId}
                            x1="0"
                            y1="0"
                            x2="1"
                            y2="1"
                        >
                            <stop offset="0" stopColor="#E61C24" />
                            <stop offset="0.5" stopColor="#ffffff" stopOpacity="0.75" />
                            <stop offset="1" stopColor="#00F0FF" />
                        </linearGradient>
                        <filter
                            id={glowId}
                            x="-80%"
                            y="-80%"
                            width="260%"
                            height="260%"
                        >
                            <feGaussianBlur stdDeviation="5" result="b" />
                            <feMerge>
                                <feMergeNode in="b" />
                                <feMergeNode in="SourceGraphic" />
                            </feMerge>
                        </filter>
                    </defs>
                    <path
                        id={orbitPathId}
                        d="M 200 38 A 162 162 0 1 1 199.9 38"
                        fill="none"
                        stroke={`url(#${ringGradId})`}
                        strokeWidth="2"
                        strokeDasharray="6 14"
                        opacity="0.55"
                    />
                    <circle r="6" fill="#00F0FF" filter={`url(#${glowId})`}>
                        <animateMotion dur="5.5s" repeatCount="indefinite">
                            <mpath href={`#${orbitPathId}`} />
                        </animateMotion>
                    </circle>
                    <circle r="4.5" fill="#FF4D55" filter={`url(#${glowId})`}>
                        <animateMotion
                            dur="8s"
                            repeatCount="indefinite"
                            begin="2.4s"
                        >
                            <mpath href={`#${orbitPathId}`} />
                        </animateMotion>
                    </circle>
                    <circle r="3.5" fill="#ffffff" filter={`url(#${glowId})`}>
                        <animateMotion
                            dur="11s"
                            repeatCount="indefinite"
                            begin="4.8s"
                        >
                            <mpath href={`#${orbitPathId}`} />
                        </animateMotion>
                    </circle>
                </svg>
            )}
            <div className="logo-fx-frame relative mx-auto aspect-square w-[64%]">
                <img
                    src="/eway-logo.jpg"
                    alt="Eway Fibre Net"
                    className="h-full w-full object-cover"
                    loading="eager"
                />
            </div>
        </div>
    );
};
